import { render } from "./HomeHead.vue?vue&type=template&id=35d4de54"
const script = {}

import "./HomeHead.vue?vue&type=style&index=0&id=35d4de54&lang=less&scopde=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__